import { useEvent, useList, useStore } from 'effector-react'
import {
    $foundSuggestions,
    $isFoundSuggestions,
    $suggestSearchPending,
    searchSuggestion,
    selectSuggestion
} from 'src/features/suggestions/model'
import MobileRowItem, { MobileRowSkeleton } from '@mobileShared/MobileRowItem/MobileRowItem'
import * as S from './mobile.styled'
import React from 'react'
import styled from 'styled-components'
import { $searchText } from 'src/features/search-goods/model'
import dynamic from 'next/dynamic'

const Container = styled.div`
    width: 100%;
    overflow: auto;
    height: 100%;
`

const HistoryBlock = dynamic(() => import('./history-mobile').then((x) => x.HistoryBlock), {
    ssr: false
})

function SearchAllBlock() {
    const text = useStore($searchText)
    const searchHandler = useEvent(searchSuggestion)
    if (!text || text.length < 3) return <React.Fragment />
    return (
        <React.Fragment>
            <MobileRowItem clickHandler={() => searchHandler(text)} isShowedRow>
                <S.Container>
                    <S.SpanDataItem>{text}</S.SpanDataItem>
                    <S.ChangeTitle>Все результаты поиска</S.ChangeTitle>
                </S.Container>
            </MobileRowItem>
        </React.Fragment>
    )
}

export function SuggestionsSearchMobile() {
    const select = useEvent(selectSuggestion)
    const isLoading = useStore($suggestSearchPending)
    //const searchTerm = useStore($searchTerm)
    const isNotEmpty = useStore($isFoundSuggestions)
    const selectHandler = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        const id = (e.currentTarget as HTMLDivElement)?.getAttribute('data-row-id')
        if (id === null) throw new Error('Error on select suggestion id not found')
        select(id)
    }

    const suggestions = useList($foundSuggestions, {
        fn: (item) => (
            <MobileRowItem clickHandler={selectHandler} aProps={{ 'data-row-id': item.id }} isShowedRow>
                <S.Container>
                    <S.SpanDataItem>{item.title}</S.SpanDataItem>
                    <S.ChangeTitle>{item.suggestionTypeTitle}</S.ChangeTitle>
                </S.Container>
            </MobileRowItem>
        ),
        //keys: [searchTerm],
        getKey: (item) => item.id
    })

    return (
        <Container>
            {isLoading ? (
                <MobileRowSkeleton />
            ) : (
                <React.Fragment>
                    {suggestions}
                    <SearchAllBlock />
                    {!isNotEmpty && <HistoryBlock selectHandler={selectHandler} />}
                </React.Fragment>
            )}
        </Container>
    )
}
